import classNames from "./CompaniesSlider.module.css";
// import linkedinImg from "../../../assets/companies/linkedin.svg";
// import uberImg from "../../../assets/companies/uber.svg";
import byrneImg from "../../../assets/companies/byrne.svg";
import atlasCopcoImg from "../../../assets/companies/atlas_copco.svg";
// import nerdwalletImg from "../../../assets/companies/nerdwallet.webp";
import nacImg from "../../../assets/companies/nac.webp";
import threatmarkImg from "../../../assets/companies/threatmark.svg";
import universityOfWaterlooImg from "../../../assets/companies/university_of_waterloo.webp";
import rocheImg from "../../../assets/companies/roche.webp";
import columbiaUniversityImg from "../../../assets/companies/columbia_university.webp";
// import hycImg from "../../../assets/companies/hyc.svg";
// import docusignImg from "../../../assets/companies/docusign.webp";
// import indeedImg from "../../../assets/companies/indeed.webp";
import meetsmoreImg from "../../../assets/companies/meetsmore.webp";
import forgeworksImg from "../../../assets/companies/forgeworks.webp";
import filuetImg from "../../../assets/companies/filuet.webp";
import velvacImg from "../../../assets/companies/velvac.webp";
import windsorOneImg from "../../../assets/companies/windsor_one.webp";
import cooperImg from "../../../assets/companies/cooper.webp";
import gakkenImg from "../../../assets/companies/gakken.webp";
import deutscheBahnImg from "../../../assets/companies/deutsche_bahn.svg";
import pneumatImg from "../../../assets/companies/pneumat.webp";
import icustomerImg from "../../../assets/companies/icustomer.webp";
import aquasightImg from "../../../assets/companies/aquasight.svg";
import officineRigamontiImg from "../../../assets/companies/officine_rigamonti.webp";
import travoriumImg from "../../../assets/companies/travorium.webp";
import bmgMoneyImg from "../../../assets/companies/bmg_money.svg";
import lbmxImg from "../../../assets/companies/lbmx.svg";
import elecmetalImg from "../../../assets/companies/elecmetal.webp";
import efsImg from "../../../assets/companies/efs.webp";
import allieImg from "../../../assets/companies/allie.webp";
import uscImg from "../../../assets/companies/usc.webp";
import misImg from "../../../assets/companies/mis.webp";
import uddImg from "../../../assets/companies/udd.webp";
import frodaImg from "../../../assets/companies/froda.svg";
import wshuhsImg from "../../../assets/companies/wshuhs.webp";
import salesianSistersImg from "../../../assets/companies/salesian_sisters.webp";
import bahaisImg from "../../../assets/companies/bahais.webp";
import padelGroupImg from "../../../assets/companies/360_padel_group.webp";

const companies = [
  // {
  //   name: "Linkedin",
  //   image: linkedinImg,
  // },
  // {
  //   name: "Uber",
  //   image: uberImg,
  // },
  {
    name: "Byrne",
    image: byrneImg,
  },
  {
    name: "Atlas Copco",
    image: atlasCopcoImg,
  },
  // {
  //   name: "Nerdwallet",
  //   image: nerdwalletImg,
  // },
  {
    name: "New Apostolic Church",
    image: nacImg,
  },
  {
    name: "University of Waterloo",
    image: universityOfWaterlooImg,
  },
  {
    name: "Roche",
    image: rocheImg,
  },
  {
    name: "Columbia University",
    image: columbiaUniversityImg,
  },
  // {
  //   name: "HY-C",
  //   image: hycImg,
  // },
  // {
  //   name: "DocuSign",
  //   image: docusignImg,
  // },
  // {
  //   name: "Indeed",
  //   image: indeedImg,
  // },
  {
    name: "Meetsmore",
    image: meetsmoreImg,
  },
  {
    name: "ForgeWorks",
    image: forgeworksImg,
  },
  {
    name: "Filuet",
    image: filuetImg,
  },
  {
    name: "Velvac",
    image: velvacImg,
  },
  {
    name: "Windsor One",
    image: windsorOneImg,
  },
  {
    name: "Cooper Machinery Services",
    image: cooperImg,
  },
  {
    name: "Gakken LX",
    image: gakkenImg,
  },
  {
    name: "Deutsche Bahn",
    image: deutscheBahnImg,
  },
  {
    name: "Pneumat Systems",
    image: pneumatImg,
  },
  {
    name: "iCustomer",
    image: icustomerImg,
  },
  {
    name: "Aquasight",
    image: aquasightImg,
  },
  {
    name: "Officine Rigamonti",
    image: officineRigamontiImg,
  },
  {
    name: "Travorium",
    image: travoriumImg,
  },
  {
    name: "BMG Money",
    image: bmgMoneyImg,
  },
  {
    name: "LBMX",
    image: lbmxImg,
  },
  {
    name: "Threatmark",
    image: threatmarkImg,
  },
  {
    name: "ME Elecmetal",
    image: elecmetalImg,
  },
  {
    name: "EFS Group",
    image: efsImg,
  },
  {
    name: "Allie AI",
    image: allieImg,
  },
  {
    name: "University of Southern California",
    image: uscImg,
  },
  {
    name: "Munich International School",
    image: misImg,
  },
  {
    name: "Universidad del Desarrollo",
    image: uddImg,
  },
  {
    name: "Froda",
    image: frodaImg,
  },
  {
    name: "William S. Hart Union High School District",
    image: wshuhsImg,
  },
  {
    name: "Missionary Society of the Salesian Sisters",
    image: salesianSistersImg,
  },
  {
    name: "The Bahá'í House of Worship",
    image: bahaisImg,
  },
  {
    name: "360 Padel Group",
    image: padelGroupImg,
  },
];

const CompaniesSlider = () => {
  return (
    <div className={classNames.Companies}>
      <div className={classNames.ImageSlider}>
        {companies.concat(companies.reverse()).map((comapany, index) => (
          <img key={index} src={comapany.image} alt={comapany.name} />
        ))}
      </div>
    </div>
  );
};

export default CompaniesSlider;
